// extracted by mini-css-extract-plugin
export default {"inlineText":"text_inlineText__DpLZO","text":"text_text__RshKR","label":"text_label__CSVx4"};